module.exports = __webpack_public_path__ + "img/12.14614646.png";